import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/hooks/use-language';

interface Tournament {
  id: string;
  name: string;
  created_at: string;
}

export default function PastTournaments() {
  const [tournaments, setTournaments] = useState<Tournament[]>([]);
  const navigate = useNavigate();
  const { t } = useLanguage();

  useEffect(() => {
    const load = async () => {
      try {
        const stored = JSON.parse(localStorage.getItem('pastTournamentIds') || '[]');
        let list: Tournament[] = [];
        if (Array.isArray(stored) && stored.length) {
          const { data, error } = await supabase
            .from('tournaments')
            .select('id, name, created_at')
            .in('id', stored)
            .order('created_at', { ascending: false });
          if (!error && data) list = data as Tournament[];
        }
        if (!list.length) {
          // Fallback: fetch completed tournaments from DB
          const { data } = await supabase
            .from('tournaments')
            .select('id, name, created_at')
            .eq('is_completed', true)
            .order('created_at', { ascending: false })
            .limit(25);
          list = (data || []) as Tournament[];
        }
        setTournaments(list);
      } catch (err) {
        console.error('Failed to load past tournaments', err);
      }
    };
    load();
  }, []);

  if (tournaments.length === 0) {
    return (
      <div className="space-y-4">
        <h1 className="text-3xl font-bold text-foreground">{t('tournament.past_tournaments')}</h1>
        <p className="text-muted-foreground">{t('tournament.no_past_tournaments')}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-bold text-foreground">{t('tournament.past_tournaments')}</h1>
      <div className="space-y-2">
        {tournaments.map(tournament => (
          <Card
            key={tournament.id}
            className="cursor-pointer hover:bg-accent"
            onClick={() => navigate(`/tournaments/${tournament.id}`)}
          >
            <CardHeader>
              <CardTitle>{tournament.name}</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              {new Date(tournament.created_at).toLocaleDateString()}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
